import { render, staticRenderFns } from "./MaterialDonationCollectionsModal.vue?vue&type=template&id=007f5325&"
import script from "./MaterialDonationCollectionsModal.vue?vue&type=script&lang=js&"
export * from "./MaterialDonationCollectionsModal.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDonationCollectionsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports